import { theme } from 'antd';

export const darkTheme = {
    algorithm: theme.darkAlgorithm,
    token: {
        // Base colors
        colorBgBase: '#0a0b0d',
        colorBgContainer: '#12141a',
        colorBgElevated: '#1a1d24',
        colorBgLayout: '#0a0b0d',

        // Primary color
        colorPrimary: '#818cf8',
        colorPrimaryHover: '#6366f1',

        // Text colors
        colorText: '#f8f9fa',
        colorTextSecondary: '#9ca3af',
        colorTextTertiary: '#6b7280',

        // Border
        colorBorder: '#2a2f3a',
        colorBorderSecondary: '#22262f',

        // Radii
        borderRadius: 6,
        borderRadiusLG: 8,
        borderRadiusSM: 4,

        // Control heights (globally controllable)
        controlHeight: 40,
        controlHeightLG: 48,
        controlHeightSM: 32,

        // Spacing (globally controllable)
        margin: 16,
        marginLG: 24,
        marginMD: 16,
        marginSM: 12,
        marginXS: 8,

        padding: 16,
        paddingLG: 24,
        paddingMD: 16,
        paddingSM: 12,

        // Font
        fontSize: 14,
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    },
    components: {
        Layout: {
            // Header configuration
            headerBg: '#12141a',
            headerHeight: 60,
            headerPadding: '0 24px',
            headerColor: '#f8f9fa',

            // Sider configuration 
            siderBg: '#12141a',

            // Body configuration
            bodyBg: '#0a0b0d',

            // Trigger configuration
            triggerBg: '#1a1d24',
            triggerColor: '#f8f9fa',
            triggerHeight: 48,
        },
        Menu: {
            darkItemBg: 'transparent',
            darkItemSelectedBg: 'rgba(129, 140, 248, 0.15)',
            darkItemHoverBg: '#1a1d24',
            darkItemColor: '#9ca3af',
            darkItemSelectedColor: '#818cf8',
            darkSubMenuItemBg: '#0f1116',
            darkGroupTitleColor: '#6b7280',
            iconSize: 18,
            itemMarginInline: 0,
            itemBorderRadius: 6,
            itemHeight: 40,
            collapsedWidth: 80,
            collapsedIconSize: 18,
        },
        Button: {
            colorBgTextHover: '#1a1d24',
            colorBgTextActive: '#22262f',
        },
        Card: {
            colorBgContainer: '#12141a',
            colorBorderSecondary: '#2a2f3a',
        },
        Input: {
            colorBgContainer: '#12141a',
            colorBorder: '#2a2f3a',
        },
        Modal: {
            contentBg: '#12141a',
            headerBg: '#12141a',
            footerBg: '#12141a',
        },
    },
};

export const lightTheme = {
    algorithm: theme.defaultAlgorithm,
    token: {
        // Base colors
        colorBgBase: '#ffffff',
        colorBgContainer: '#ffffff',
        colorBgElevated: '#ffffff',
        colorBgLayout: '#f5f5f7',

        // Primary color
        colorPrimary: '#6366f1',
        colorPrimaryHover: '#4f46e5',

        // Text colors
        colorText: '#1f2937',
        colorTextSecondary: '#4b5563',
        colorTextTertiary: '#6b7280',

        // Border
        colorBorder: '#e5e7eb',
        colorBorderSecondary: '#f3f4f6',

        // Radii
        borderRadius: 6,
        borderRadiusLG: 8,
        borderRadiusSM: 4,

        // Control heights (globally controllable)
        controlHeight: 40,
        controlHeightLG: 48,
        controlHeightSM: 32,

        // Spacing (globally controllable)
        margin: 16,
        marginLG: 24,
        marginMD: 16,
        marginSM: 12,
        marginXS: 8,

        padding: 16,
        paddingLG: 24,
        paddingMD: 16,
        paddingSM: 12,

        // Font
        fontSize: 14,
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    },
    components: {
        Layout: {
            // Header configuration
            headerBg: '#ffffff',
            headerHeight: 60,
            headerPadding: '0 24px',
            headerColor: '#1f2937',

            // Sider configuration 
            siderBg: '#ffffff',

            // Body configuration
            bodyBg: '#f5f5f7',

            // Trigger configuration
            triggerBg: '#f3f4f6',
            triggerColor: '#1f2937',
            triggerHeight: 48,
        },
        Menu: {
            itemBg: 'transparent',
            itemSelectedBg: 'rgba(99, 102, 241, 0.1)',
            itemHoverBg: '#f3f4f6',
            itemColor: '#4b5563',
            itemSelectedColor: '#6366f1',
            subMenuItemBg: '#f9fafb',
            groupTitleColor: '#6b7280',
            iconSize: 18,
            itemMarginInline: 0,
            itemBorderRadius: 6,
            itemHeight: 40,
            collapsedWidth: 80,
            collapsedIconSize: 18,
        },
        Button: {
            colorBgTextHover: '#f3f4f6',
            colorBgTextActive: '#e5e7eb',
        },
        Card: {
            colorBgContainer: '#ffffff',
            colorBorderSecondary: '#e5e7eb',
        },
        Input: {
            colorBgContainer: '#ffffff',
            colorBorder: '#e5e7eb',
        },
        Modal: {
            contentBg: '#ffffff',
            headerBg: '#ffffff',
            footerBg: '#ffffff',
        },
    },
};

// Helper function to get theme based on mode
export const getAntdTheme = (resolvedTheme) => {
    return resolvedTheme === 'dark' ? darkTheme : lightTheme;
};
